import { Input, Label } from '@windmill/react-ui';
import { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import EditableForm from 'src/models/editableForm';
import EditableInput from 'src/components/_common/EditableInput/EditableInput';

const AdminFormQuestionOptions = ({ form: form, handleSetFormHelpText: handleSetFormHelpText }: {form: EditableForm, handleSetFormHelpText: (helpText: string) => void}) => {
  const [showCommentField, toggleShowCommentField] = useState<boolean>(!!form?.helpText);

  useEffect(() => {
    if (!showCommentField)handleSetFormHelpText('');
  }, [showCommentField]);

  return (
    <div className="contents">
      <Label>
        <Input
          type="checkbox"
          defaultChecked={!!form?.helpText}
          value="supervisor-text"
          onChange={() => toggleShowCommentField(!showCommentField)}
          onPointerEnterCapture={() => {}}
          onPointerLeaveCapture={() => {}}
          css=""
          crossOrigin={undefined}
        />
        <span className="text-black"><FormattedMessage id="form-introduction-text" /></span>
      </Label>
      {showCommentField
        && (
        <Label className="mt-4">
          <span><FormattedMessage id="edit-form-introduction-text" /></span>
          <EditableInput
            text={form?.helpText}
            active
            onChangeHandler={value => handleSetFormHelpText(value)}
          />
        </Label>
        )}
    </div>
  );
};

export default AdminFormQuestionOptions;
